module.exports = __webpack_public_path__ + "static/image-04-a@2x-6fe9d505d2220dae37284374243ff1a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/laboratoria/image-04-a@2x.jpg
// module id = 391
// module chunks = 3627797113349 20562973939449 33019919093843